<template>
  <div class="container">
    <keep-alive exclude="LogisticsMap">
      <div class="no_logistics" v-if="noLogistics == true">
        当前订单无物流信息
      </div>
      <div class="have_lt" v-else>
        <div class="if_box" v-if="showMap == true">
          <iframe id="map_iframe" :src="totalData.routeMapUrl" width="100%" height="800rpx" frameborder="0" scrolling="auto">
                                      </iframe>
        </div>
        <div :class="noMap == true ? 'ltInfo_box_noMap' : 'ltInfo_box'">
          <div class="info_title">
            <div class="multi_express" v-show="expressCount>1" @click="openExpressListPopup">该订单被分成{{ expressCount }}个包裹，点击查看全部
            </div>
            <div class="express_box">
              <div class="express_Info">
                <div>{{ totalData.logisticsName }}:</div>
                <div id="logisticsNumber">{{ totalData.logisticsNumber }}</div>
              </div>
              <div class="copyBtn" @click="copyNumber()">复制</div>
            </div>
          </div>
          <div class="address-box">收货地址：{{ totalData.receiveAddress }}</div>
          <van-steps :active="0" direction="vertical" active-icon="checked" active-color="#F75E32">
            <van-step v-for="(item, index) in logisticsData" :key="index">
              <div class="step_box">
                <h3 style="text-align: left">{{ item.logStatus }}</h3>
                <p style="text-align: left">{{ item.createTime }}</p>
              </div>
            </van-step>
          </van-steps>
        </div>
      </div>
    </keep-alive>
    <van-popup v-model="showExpressListPopup" :overlay="true" :safe-area-inset-bottom="true" close-icon-position="top-right" position="bottom" :style="{ height: '40%' }">
      <div class="pop_box">
        <div class="pop_title">该订单被分成{{ expressCount }}个包裹</div>
        <div class="pop_content">
          <div class="ex_item" v-for="(exItem,exIndex) in totalData.traceList" :key="exIndex" @click="openNewExpress(exItem)">
            <img src="@/assets/bag.svg" style="width: 70px;height: 70px;margin-right: 10px;" alt="">
            <div class="ex_left">
              <div class="ex_status" v-show="exItem.status == 0">暂无轨迹信息</div>
              <div class="ex_status" v-show="exItem.status == 1">已揽收</div>
              <div class="ex_status" v-show="exItem.status == 2">在途中</div>
              <div class="ex_status" v-show="exItem.status == 3">签收</div>
              <div class="ex_status" v-show="exItem.status == 4">问题件</div>
              <div class="ex_status" v-show="exItem.status == 5">转寄</div>
              <div class="ex_status" v-show="exItem.status == 6">清关</div>
              <div class="exl">
                {{ exItem.logisticsName }}:{{ exItem.logisticsNumber }}
              </div>
              <div class="exl">
                {{ exItem.lastTrace }}
              </div>
            </div>
            <van-icon name="arrow" />
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
  import axios from "axios";
  export default {
    name: "LogisticsMapNew",
    components: {},
    data() {
      return {
        logisticsData: [],
        totalData: [],
        expressCount: '',
        logisticsId: '',
        BASEURL: '',
        mapUrl: '',
        noLogistics: false,
        noMap: false,
        showExpressListPopup: false,
        showMap: false
      };
    },
    created() {
      console.log('oooooo')
      if (this.$route.query.orderId) {
        this.logisticsId = this.$route.query.orderId;
        this.BASEURL = this.$route.query.BASEURL;
        console.log("logisticsId:>>", this.logisticsId);
        console.log("baseUrl:>>", this.BASEURL);
        this.getLogistics(this.logisticsId, 0);
      }else{
        this.noLogistics = true
      }
      
    },
    onload() {},
    methods: {
      openNewExpress(item) {
        console.log(item)
        this.getLogistics(item.id, 1)
      },
      openExpressListPopup() {
        this.showExpressListPopup = !this.showExpressListPopup
      },
      async copyNumber() {
        try {
          await navigator.clipboard.writeText(document.getElementById('logisticsNumber').innerHTML)
          // alert(document.getElementById('logisticsNumber').innerHTML)
          // alert('复制成功')
          this.$toast('复制成功' + document.getElementById('logisticsNumber').innerHTML)
        } catch (err) {
          this.$toast('复制成功')
        }
      },
      getLogistics(logisticsId, type) {
        this.totalData = []
        this.logisticsData = []
        this.showMap = false
        console.log('showMap', this.showMap)
        // 测试服务器：101.42.248.138：21
        // 正式服务器：114.55.107.49：21
        // 账号密码    yunfendaWeb    yunfendaWeb@123
        console.log("logisticsId::" + logisticsId);
        // this.BASEURL = 'https://testapi.yunfenda.com/'
        // let logisticsId = '1791284242668457984'
        if (type == 0) {
          console.log('默认进入')
          this.url = 'u058-business/mall/v1/mallgoodorderinvoice/getExpressInvoiceLogByOrderId'
        } else {
          console.log('弹窗进入')
          this.url = 'u058-business/mall/v1/mallgoodorderinvoice/getExpressInvoiceLogByTraceId'
        }
        axios
          .post(
            this.BASEURL + this.url, {
              id: logisticsId,
              // id: '1791284242668457984'
            }
          )
          .then((res) => {
            if (res.data.code == 0) {
              if (res.data.dataInfo) {
                this.showExpressListPopup = false
                console.log('当前接口',this.url)
                console.log(res.data.dataInfo);
                this.totalData = res.data.dataInfo
                this.expressCount = this.totalData.traceList.length
                console.log('共有' + this.expressCount + '个包裹')
                this.logisticsData = res.data.dataInfo.invoiceTraceList.reverse();
                console.log(this.logisticsData);
                if (this.totalData.routeMapUrl != '') {
                  console.log('发货时间：' + new Date(this.totalData.deliveryTime))
                  console.log('当前时间：' + new Date())
                  console.log('==================================')
                  console.log('发货时间戳：' + new Date(this.totalData.deliveryTime).getTime())
                  console.log('当前时间戳：' + new Date().getTime())
                  let timeDiff =
                    new Date().getTime() -
                    new Date(this.totalData.deliveryTime).getTime();
                  let daysDiff = Math.floor(timeDiff / (24 * 3600 * 1000));
                  console.log('相差：' + daysDiff)
                  if (daysDiff >= 39) {
                    this.noMap = true;
                    console.log('this.noMap = true')
                  } else {
                    this.showMap = true
                    console.log('showMap', this.showMap)
                    console.log('routeMapUrl', this.totalData.routeMapUrl)
                    this.$forceUpdate()
                  }
                } else {
                  this.noMap = true;
                }
              } else {
                this.noLogistics = true;
              }
            } else {
              this.noLogistics = true;
              this.$toast({
                message: `<div style="height:50px;display:flex;justify-content: center;align-items: center;"><span>` +
                  res.data.msg +
                  `,请返回查看其他订单物流详情</span></div>`,
                type: "html",
                position: "top",
              });
            }
          });
      },
    },
  };
</script>

<style type="text/css">
  .container {
    position: relative;
    height: 100vh;
  }
  .have_lt {
    position: relative;
    height: 100vh;
  }
  .no_logistics {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .if_box {
    height: 40%;
  }
  #map_iframe {
    /* position: relative;
                                top: 0px;
                                left: 0px;
                                z-index: -1;
                                filter: alpha(opacity=0) */
    width: 100%;
    height: 100%;
  }
  .ltInfo_box_noMap {
    width: 100%;
    height: 100%;
    overflow-y: auto;
    background: #ffffff;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: 99;
  }
  .ltInfo_box {
    width: 100%;
    height: 60%;
    overflow-y: auto;
    background: #ffffff;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 99;
  }
  .info_title {
    display: flex;
    flex-direction: column;
    margin-top: 10px;
    padding: 10px 20px;
  }
  .multi_express {
    color: #F75E32;
    font-size: 16px;
    text-align: left;
  }
  .express_box {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .express_Info {
    color: #666666;
    font-size: 14px;
    display: flex;
    align-items: center;
  }
  .copyBtn {
    width: 38px;
    height: 25px;
    color: #43CF7C;
    border: 1px solid #666666;
    text-align: center;
    line-height: 21px;
    border-radius: 4px;
    padding: 2px;
  }
  .address-box {
    text-align: left;
    padding: 10px 20px;
    color: #666666;
  }
  .step_box {
    margin-left: 5px;
    margin-top: -14px;
  }
  .van-icon-checked:before {
    font-size: 22px;
  }
  .van-step__circle {
    width: 10px;
    height: 10px;
  }
  .pop_box {
    padding: 20px;
    font-size: 16px;
  }
  .pop_title {
    font-weight: 600;
    color: #333333;
  }
  .pop_content {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    margin-top: 20px;
  }
  .ex_item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 40px;
    margin: 20px 0;
  }
  .ex_left {
    width: 70%;
    /* line-height: 20px; */
  }
  .ex_status {
    text-align: left;
    color: #333333;
    font-size: 16px;
    font-weight: 600;
  }
  .exl {
    text-align: left;
    font-size: 14px;
    color: #999999;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
  }
</style>


// WEBPACK FOOTER //
// src/views/webview/logisticsMapNew.vue